export const SET_LICENSES = 'SET_LICENSES'
export const ADD_LICENSE = 'ADD_LICENSE'
export const SET_LICENSE = 'SET_LICENSE'
export const SET_LOADING = 'SET_LOADING'
export const CLEAR_LICENSE = 'CLEAR_LICENSE'
export const SET_LICENSE_LIST = 'SET_LICENSE_LIST'
export const SET_LIST_LOADING = 'SET_LIST_LOADING'
export const SET_API_CONFIG = 'SET_API_CONFIG'
